import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Btn } from './styles';

const Button = forwardRef(
  (
    {
      id = null,
      children,
      onClick = null,
      type = 'btn-primary',
      className = '',
      size = '',
      icon = '',
      placement = false,
      disabled = false,
      isActive = false,
    },
    ref,
  ) => {
    return (
      <Btn
        id={id}
        className={`${className} ${type} ${size}`}
        icon={icon}
        placement={placement}
        onClick={onClick}
        isActive={isActive}
        disabled={disabled}
        ref={ref}
      >
        {children}
      </Btn>
    );
  },
);

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  placement: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default Button;
